// removed by extract-text-webpack-plugin
module.exports = {"icon":"_3hcQqrEq8FFT7SnFtDlbDB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/helpIconTooltip/styles.css
// module id = 1623
// module chunks = 0